export const documentationRootGuid = 'a9430777-bb55-4e07-8bf9-6ddaf12eac1e'
export const fullDocumentationRootGuid = '9407f1f0-43b4-425e-b0f2-adc0866bec90'
export const buildingImagesRootGuid = '644dedf9-5a31-4dbe-8f48-0646cd55da26'
export const plansRootGuid = '394d48bb-3ae5-4817-9c9b-b1be4ab8e8a9'
export const floorplanImagesRootGuid = '79976b56-6941-4d3e-95f1-d6b19d19e83d'
export const ifcRootGuid = '5ed37eeb-6075-4e0a-bb4b-562aa0760dde'
export const planImageCardAssetsRootGuid = 'b7e8f9a0-1c2d-4e3f-9a8b-7c6d5e4f3a2b'
// Files uploaded to the project for the document manager ("Dateien"), shown by
// markdown pages via FileItem.attachment
export const projectFilesRootGuid = '0f3b6c1e-5d2a-4c8e-9b7f-2a6d4e8c1f35'
